import React from 'react';
import { AdminNav } from './AdminNav';
import { ProfileCopyrightFooter } from '@components';

export const AdminLayout = ({ children }) => {
    return (
        <>
            <AdminNav />
                {children}
            <ProfileCopyrightFooter profile='Strategic Financial Solutions' />
        </>
    );
};

export default AdminLayout;